/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create market making platform request
 */
export interface CreateMarketMakingPlatformRequest {
  /**
   * Platform name as sent by the market making service, e.g. ZEROHASH
   */
  name: string;
  /**
   * Human readable label, e.g. New Zerohash
   */
  displayName: string;
  /**
   * URL path segment of the platform API, e.g. kaali-zerohash-api
   */
  apiPath?: string;
  /**
   * Ledger account id used for hedging on this platform. When unset the UI hides the links to the account and its trades.
   */
  hedgeAccountId?: number;
  /**
   * Hidden platforms are not offered in the UI
   */
  hidden: boolean;
}
